export const NOTIFICATION_LIMIT = 10;
